import OrganisationCard from "../components/OrganisationCard";
const OrganisationCardContainer = (props) => {
    const organisations = props.organisations;
    const showHidden = props.showHidden;

    return (
        <div className="organisation-card-container">
            {organisations && organisations.map((organisation, idx) => {
                if(!organisation.hidden || organisation.demo || showHidden) {
                    return <OrganisationCard organisation={organisation} handleClick={props.handleClick} key={idx}/>
                }
            })}
        </div>
    )
}
export default OrganisationCardContainer
